import ExpandedCenterPanel from "./ExpandedCenterPanel";
import ExpandedLeftPanel from "./ExpandedLeftPanel";

export default function ChatBotExpanded({
  activeChat,
  chats,
  loadChat,
  createNewChat,
  msg,
  setMsg,
  onSend,
  isTyping,
  mode,
  handleModeChange,
  setFollowUpRef,
  activeChatId,
  hasTyped,
  currentMessages,
  setMessages,
  onClearFollowup,
  setChats,
  onBack,
  streamingMessageId,
}) {
  return (
    <div className="expanded-wrapper">
      <div className="expanded-left-container">
        <ExpandedLeftPanel
          onNewChat={createNewChat}
          chats={chats}
          activeChatId={activeChatId}
          loadChat={loadChat}
          mode={mode}
          handleModeChange={handleModeChange}
          hasTyped={hasTyped}
        />
      </div>

      <div className="expanded-center-container">
        <ExpandedCenterPanel
          // messages={activeChat?.messages || []}
          messages={activeChatId ? activeChat?.messages || [] : currentMessages}
          msg={msg}
          setMsg={setMsg}
          onSend={onSend}
          isTyping={isTyping}
          mode={mode}
          setMessages={(newMsgs) => {
            setChats((prev) =>
              prev.map((chat) =>
                chat.id === activeChatId ? { ...chat, messages: newMsgs } : chat
              )
            );
          }}
          onClearFollowup={() => setFollowUpRef(null)}
          onBack={onBack}
          streamingMessageId={streamingMessageId}
        />
      </div>
    </div>
  );
}
